import { render, staticRenderFns } from "./BotonesProcesoPreguntas.vue?vue&type=template&id=3370781b&"
import script from "./BotonesProcesoPreguntas.vue?vue&type=script&lang=js&"
export * from "./BotonesProcesoPreguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports